import { TemplateRef } from '@angular/core';

export class DeSnackbarData {
  type?: DeSnackbarType;
  text?: string;
  clickEventContent?: string;
  showCloseIcon?: boolean;
  linkText?: string;
  duration?: number;
  mobilePosition?: DeSnackbarPosition;
  desktopPosition?: DeSnackbarPosition;
  _position?: DeSnackbarPosition;
  desktopOffset?: number;
  mobileOffset?: number;
}

export type DeSnackbarType = 'warning' | 'default' | 'success';

export type DeSnackbarPosition = 'top' | 'bottom';
